<template>
  <div class="bottom-right-3">
    <BorderBoxView1 title="报修服务">
      <div class="box-top">
        <XidiItem2 :list="xidiValue1"></XidiItem2>
        <XidiItem2 :list="xidiValue2"></XidiItem2>
      </div>
      <div class="box-bottom">
        <dv-scroll-board :config="config" />
      </div>
    </BorderBoxView1>
  </div>
</template>

<script>
import BorderBoxView1 from "./border/borderBoxView1";
import XidiItem2 from "./xidiItem2";
import {assign} from "xe-utils";
import {mapState} from "vuex";
export default {
  name: 'BottomRight3',
  components: {BorderBoxView1, XidiItem2},
  computed: {
    ...mapState({
      data: function(state) {
        return state.user.data
      }
    }),
  },
  watch:{
    data (newValue){
      if(newValue){
        let data = newValue
        if(data.baoxiu){
          let config = assign(true, this.config)
          config.data = []
          data.baoxiu.list.map((res, key) => {
            config.data.push([this.$padding4((key + 1).toString(), 2), res.address, res.mate_name, res.name, res.created_at])
          })
          this.config = config
          let xidiValue1 = JSON.parse(JSON.stringify(this.xidiValue1))
          let xidiValue2 = JSON.parse(JSON.stringify(this.xidiValue2))

          xidiValue1[0].value = parseInt(data.baoxiu.today_count)

          xidiValue2[0].value = parseInt(data.baoxiu.count)


          this.xidiValue1 = xidiValue1
          this.xidiValue2 = xidiValue2
        }
      }
    }
  },
  data() {
    return {
      config: {
        header: ['序号', '维修位置', '维修内容', '汇报人', '服务时间'],
        data: [],
        align: ['center','center','center','center','center'],
        headerBGC: 'rgba(241,241,241,0.06)',
        oddRowBGC: 'rgba(241,241,241,0.06)',
        evenRowBGC: 'rgba(241,241,241,0)',
        rowNum: 2
      },
      xidiValue1: [
        {
          label: '今日维修工单数据',
          value: '13单',
          icon: require('../assets/icon0.png'),
          valueColor: '#7EE0C1'
        }
      ],
      xidiValue2: [
        {
          label: '累计维修工单数据',
          value: '706单',
          icon: require('../assets/icon0.png'),
          valueColor: '#7EE0C1'
        }
      ],
    }
  }
}
</script>
<style scoped lang="scss">
.bottom-right-3{
  width: 100%;
  height: 28%;
  margin-top: 10%;
  .box-top{
    height: 30%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 3%;
  }
  .box-bottom{
    height: 50%;
    margin-top: 5%;
    margin-bottom: 5%;
  }
}
</style>
